import classNames from "classnames";
import type { AnchorHTMLAttributes } from "react";
import type React from "react";

import style from "./Link.module.css";

export const Link: React.FC<AnchorHTMLAttributes<HTMLAnchorElement>> = ({ children, ...attrs }) => {
  let rel = attrs.rel;

  if (attrs.target === "_blank") {
    rel = rel ?? "noreferrer noopener";
  }

  return (
    <a {...attrs} className={classNames(style.link, attrs.className)} rel={rel}>
      {children}
    </a>
  );
};

Link.displayName = "Link";
